/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import { GlobalStyles, FontFamilies } from "@mostlycode/ui/theme"
import styled, { ThemeProvider, createGlobalStyle } from "styled-components"
import { NavUntoggle } from "@mostlycode/ui"
import { siteTheme } from "theme"

import { NavigationContext, ViewportContext } from "context"
import { isViewport } from "helpers"
import useViewport from "hooks/useViewport"

import Content from "components/Content"
import Cookies from "components/Cookies"
import Header from "components/Header"
import Navigation from "components/Navigation"
import OffCanvasNav from "components/OffCanvasNav"
import Footer from "components/Footer"
import SoMe from "components/SoMe"

const StyledMain = styled.main`
  position: relative;
  z-index: 1;
  // padding: 0 0 2rem;

  ${(props) => props.theme.media.tablet_landscape_up`
    // padding: 0 0 4rem;
  `}
`

const StyledNavUntoggle = styled(NavUntoggle)`
  border: none;
  background: transparent;
  transition: all ease-out 0.2s;
  color: ${(props) => props.theme.colors.primary};
  padding-right: 0;

  &:focus {
    outline: none;
  }
`

const CustomGlobal = createGlobalStyle`
  body {
    line-height: 1.5;
    font-size: ${(props) => props.theme.fontSizes.p};
  }

  h1, h2, h3, h4, h5, h6 {
    line-height: 1.3;
    margin-top: 1em;
    margin-bottom: .5em;
    font-family: ${(props) => props.theme.fontStacks.heading};
  }

  h1 {
    font-size: ${(props) => props.theme.fontSizes.h2};
  }

  h2 {
    font-size: ${(props) => props.theme.fontSizes.h3};
  }

  h3 {
    font-size: ${(props) => props.theme.fontSizes.h4};
  }

  h4 {
    font-size: ${(props) => props.theme.fontSizes.h5};
  }

  h5 {
    font-size: ${(props) => props.theme.fontSizes.h6};
  }

  h6 {
    font-size: ${(props) => props.theme.fontSizes.h6};
  }

  img {
    display: block;
  }

  ${(props) => `
    p, li, code, blockquote, address { font-size: ${props.theme.fontSizes.p}; }
    p {
      line-height: 1.6;
      margin-bottom: 0;

      &:first-child {
        margin-top: 0;
      }
    }
  `};



  a {
    color: currentColor;
    // font-weight: bold;
    transition: all ease-out .15s;
    text-decoration: none;
    font-size: inherit;

    &:hover {

    }
  }

  ul {
    list-style-position: outside;
    margin: 0;
    padding: 0;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    h1 {
      font-size: ${props.theme.fontSizes.h1};
    }

    h2 {
      font-size: ${props.theme.fontSizes.h2};
    }

    h3 {
      font-size: ${props.theme.fontSizes.h3};
    }

    h4 {
      font-size: ${props.theme.fontSizes.h4};
    }

    h5 {
      font-size: ${props.theme.fontSizes.h5};
    }

    h6 {
      font-size: ${props.theme.fontSizes.h6};
    }
  `}
`

const Layout = ({
  children,
  lang,
  site_settings: {
    main_navigation,
    footer_information,
    footer_navigations,
    social_media_links,
  },
  header_style,
  ...props
}) => {
  const [navToggled, setNavToggled] = useState(false)
  const viewport = useViewport()

  function handleNavToggle() {
    setNavToggled((prev) => !prev)
  }

  return (
    <ThemeProvider theme={siteTheme}>
      <FontFamilies />
      <GlobalStyles />
      <CustomGlobal />
      <ViewportContext.Provider value={viewport}>
        <NavigationContext.Provider value={navToggled}>
          <StyledMain>
            <Header
              header_style={header_style}
              lang={lang}
              mainNavigation={main_navigation}
              onNavToggle={handleNavToggle}
            />
            {children}
          </StyledMain>
          <Footer
            footer_information={footer_information}
            footer_navigations={footer_navigations}
            lang={lang}
          >
            <SoMe
              color="ice"
              hover="secondary"
              lang={lang}
              social_media_links={social_media_links}
            />
          </Footer>
          {isViewport(viewport, ["PHONE_ONLY", "TABLET_PORTRAIT_UP"]) && (
            <OffCanvasNav
              navToggle={
                <StyledNavUntoggle
                  withText={props.lang === "en-gb" ? "Close" : "Luk"}
                  withIcon="close"
                  onToggle={handleNavToggle}
                />
              }
              nav={<Navigation nav={main_navigation} lang={lang} />}
            >
              <Content content={footer_information} />
            </OffCanvasNav>
          )}
          <Cookies />
        </NavigationContext.Provider>
      </ViewportContext.Provider>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
